import React from 'react';

/**
 * Renders an ultra-compact, clickable social media or website link that opens in a new tab.
 * Helps prevent table rows from stretching vertically due to long URLs wrapping.
 */
export const renderCompactLink = (value: any, columnId: string) => {
  if (value === null || value === undefined) return '-';
  const urlStr = String(value).trim();
  if (urlStr === '' || urlStr === '-') return '-';

  // Check if it's actually a URL or looks like one.
  // If it's a numeric ID or doesn't have any '.' or doesn't start with www/http, render as plain text.
  const isUrl = /^https?:\/\//i.test(urlStr) || urlStr.includes('.') || urlStr.toLowerCase().startsWith('www.');
  if (!isUrl) {
    return urlStr;
  }

  // Prepend protocol if missing
  let href = urlStr;
  if (!/^https?:\/\//i.test(urlStr)) {
    href = `https://${urlStr}`;
  }

  let label = urlStr;
  const colLower = columnId.toLowerCase();

  if (colLower.includes('linkedin') && colLower !== 'linkedin_id' && colLower !== 'linkedin_group_id') {
    label = 'LI';
  } else if (colLower === 'facebook') {
    label = 'FB';
  } else if (colLower === 'youtube') {
    label = 'YT';
  } else if (colLower === 'ig' || colLower.includes('instagram')) {
    label = 'IG';
  } else if (colLower === 'twitter') {
    label = 'TW';
  } else if (colLower === 'website') {
    try {
      let cleanHref = href;
      if (!cleanHref.startsWith('http')) {
        cleanHref = 'http://' + cleanHref;
      }
      const url = new URL(cleanHref);
      label = url.hostname.replace('www.', '') + ' ↗';
    } catch {
      label = urlStr.length > 18 ? urlStr.substring(0, 15) + '... ↗' : urlStr + ' ↗';
    }
  } else {
    // Other links
    label = urlStr.length > 18 ? urlStr.substring(0, 15) + '... ↗' : urlStr + ' ↗';
  }

  return (
    <a
      href={href}
      target="_blank"
      rel="noopener noreferrer"
      style={{
        color: '#1976d2',
        textDecoration: 'none',
        fontSize: '0.8125rem',
        fontWeight: 500,
        whiteSpace: 'nowrap',
        overflow: 'hidden',
        textOverflow: 'ellipsis',
        display: 'inline-block',
        maxWidth: '100%',
        verticalAlign: 'middle',
      }}
      title={urlStr}
      onClick={(e) => e.stopPropagation()}
    >
      {label}
    </a>
  );
};
